// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3CMjO","name":"Header_name__3zxLP","birthday":"Header_birthday__1WuaX","skeleton":"Header_skeleton__2BRJy"};